module.exports = "/images/Azul_Express_v2.svg?d478b8f4cd8ec909837e55bb791bb0ff";